import * as React from 'react';

const SvgTopArrow = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={24}
    height={24}
    fill='none'
    {...props}
  >
    <g clipPath='url(#TopArrow_svg__a)'>
      <path
        d='m4.363 12 5.728-5.728v16.546h3.818V6.272L19.637 12l2.546-2.546L12-.728 1.818 9.454 4.363 12Z'
        fill='#4D4D4D'
      />
    </g>
    <defs>
      <clipPath id='TopArrow_svg__a'>
        <path fill='#fff' transform='rotate(-90 12 12)' d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
);

export default SvgTopArrow;
